import { formatValor } from '../../../../../utils/formatter/formatter'


export const getTextoMulta = ( category, valor, quantidadeKitsMulta ) => {
  if ( quantidadeKitsMulta === 0 ) {
    return `Tagger, vimos que faltam menos de 3 caixinhas para você concluir seu plano anual.

Por isso, enviaremos os kits restantes normalmente assim você fica isento da multa de cancelamento do plano anual, e sua assinatura será cancelada automaticamente após o envio do último kit.

💡 Importante: se este for o seu 12º kit, sua assinatura será encerrada logo após o envio.`
  }
  const nomeClube = category === 'curadoria' ? 'Curadoria' : 'Inéditos'
  const valorFormatado = formatValor( { valor } )
  return `Seu plano anual da Tag ${nomeClube} ainda está em andamento e, por isso, o cancelamento antecipado gera uma multa no valor de 3 caixinhas (${valorFormatado}).

Que tal continuar com a gente e aproveitar o restante do seu plano?`
}
